import script from './component-lib.esm26.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "root",
    staticClass: "v-calendly",
    class: _vm.classes,
    staticStyle: {
      "min-width": "320px",
      "height": "646px"
    }
  });
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-9d3c8aa4_0", {
    source: ".v-calendly[data-v-9d3c8aa4]{border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px)}.v-calendly--loaded[data-v-9d3c8aa4]{background:#fff}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-9d3c8aa4";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Calendly = __vue_component__;
export { Calendly as default };